// Questions-réponses du site : UNE seule source pour la page FAQ, les blocs « Questions fréquentes »
// de chaque page (composant Faq.js, qui pose aussi le balisage FAQPage lu par Google et par les
// assistants IA) et public/llms.txt (généré par minisite-factory/build.py à partir de faq.json).
// Règles d'écriture : chaque réponse se comprend SEULE (elle sera citée hors contexte), commence
// par la réponse elle-même, nomme le produit, donne le chiffre. Rien qui ne soit vrai aujourd'hui.
import { useMemo } from 'react';
import DATA from './faq.json';
import { useT } from '../i18n';

export const FAQ_GROUPES = DATA.groupes;

const parCle = Object.fromEntries(DATA.groupes.flatMap((g) => g.questions.map((q) => [q.id, q])));

// Sélections par page : liste d'identifiants de questions (faq.json).
export const FAQ_PAGES = DATA.pages;

export const faqDe = (page) => (DATA.pages[page] || []).map((id) => parCle[id]).filter(Boolean);

// Même chose dans la langue courante : le FRANÇAIS reste dans faq.json (source unique) ; les traductions
// sont dans src/i18n/locales/<langue>/faq.json, indexées par l'identifiant de la question :
//   { "groups": { "<id du groupe>": "titre" }, "questions": { "<id>": { "q": "…", "a": "…" } } }
// Question non traduite = texte français. Ni le tri ni la sélection par page ne dépendent de la langue.
export const useFaqDe = (page) => {
  const t = useT('faq');
  return useMemo(() => faqDe(page).map((item) => ({
    ...item,
    q: t.or(`faq.questions.${item.id}.q`, item.q),
    a: t.or(`faq.questions.${item.id}.a`, item.a),
  })), [t, page]);
};

// Groupes de la page FAQ, titres traduits.
export const useFaqGroupes = () => {
  const t = useT('faq');
  return useMemo(() => DATA.groupes.map((g) => ({
    ...g,
    titre: t.or(`faq.groups.${g.id}`, g.titre),
    questions: g.questions.map((item) => ({
      ...item,
      q: t.or(`faq.questions.${item.id}.q`, item.q),
      a: t.or(`faq.questions.${item.id}.a`, item.a),
    })),
  })), [t]);
};
